var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38421 15.7027C9.24354 15.9452 9.04163 16.1465 8.79869 16.2864C8.55575 16.4264 8.28032 16.5 7.99997 16.5C7.71961 16.5 7.44418 16.4264 7.20125 16.2864C6.95831 16.1465 6.7564 15.9452 6.61572 15.7027M12.801 6.30085C12.801 5.02759 12.2952 3.80647 11.3948 2.90614C10.4945 2.0058 9.27337 1.5 8.0001 1.5C6.72684 1.5 5.50572 2.0058 4.60539 2.90614C3.70506 3.80647 3.19925 5.02759 3.19925 6.30085C3.19925 11.9018 0.798828 13.5021 0.798828 13.5021H15.2014C15.2014 13.5021 12.801 11.9018 12.801 6.30085Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.25d1cac5c0f4dd2ec09a7e8314a2912a.svg";
export { ForwardRef as ReactComponent };